import React from "react";
import { useLocale } from "@/hooks/useLocale";
import { cn } from "@/lib/utils";

export const Badge = ({
  percent,
  count,
  bgColor = "none",
  percentColor,
  countColor,
  showPillBg,
  className = "",
}: {
  percent: number | undefined;
  count: number;
  bgColor?: string;
  percentColor: string;
  countColor: string;
  showPillBg: boolean;
  className?: string;
}) => {
  const locale = useLocale();
  return (
    <div
      className={cn(
        "duration-300` text-[10px] font-bold transition-opacity",
        className,
      )}
      style={{
        color: percentColor,
      }}
    >
      <div
        className={cn(
          "text-center",
          showPillBg && "rounded border px-1 py-[1px]",
        )}
        style={{
          borderColor: countColor,
          backgroundColor: bgColor,
        }}
      >
        {percent !== undefined ? `${percent}%` : "-"}
      </div>
      <div
        className="pt-[1px] text-center"
        style={{ opacity: showPillBg ? "100%" : "60%" }}
      >
        {new Intl.NumberFormat(locale).format(count)}
      </div>
    </div>
  );
};
